import React from 'react';

import {
	ORDERED_LIST_MENU_ITEM,
	TEXT_FORMATTING_SECTION,
	UNORDERED_LIST_MENU_ITEM,
} from '@atlaskit/editor-common/quick-insert/keys';
import { TEXT_FORMATTING_SECTION_RANK } from '@atlaskit/editor-common/quick-insert/rank';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import type { RegisterMenuItem } from '@atlaskit/editor-ui-control-model/types';

import type { ListPlugin } from '../../listPluginType';

import { ListQuickInsertMenuItem } from './ListQuickInsertMenuItem';

export const getListQuickInsertComponents = ({
	api,
}: {
	api: ExtractInjectionAPI<ListPlugin> | undefined;
}): RegisterMenuItem[] =>
	[
		{ item: UNORDERED_LIST_MENU_ITEM, type: 'unordered' as const },
		{ item: ORDERED_LIST_MENU_ITEM, type: 'ordered' as const },
	].map(({ item, type }) => ({
		key: item.key,
		type: item.type,
		parents: [
			{
				key: TEXT_FORMATTING_SECTION.key,
				type: TEXT_FORMATTING_SECTION.type,
				rank: TEXT_FORMATTING_SECTION_RANK[item.key],
			},
		],
		component: () => <ListQuickInsertMenuItem api={api} type={type} />,
	}));
